import styled from "styled-components";

export const ProcessingButtonContainerStyled = styled.div`
    margin-top: 20px;
    position: relative;
    width: 100%;
    max-width: 218px;

    img {
        @keyframes iconAnim {
            from {
                scale 0;
            }

            to {
                scale: 1;
            }
        }

        position: absolute;
        top: -20px;
        left: -15px;
        z-index: 1;
        animation: iconAnim 0.2s;
    }
`;

export const ProcessingButtonStyled = styled.button`
    @keyframes dotsAnim {
        from {
            opacity: 1;
        }

        to {
            opacity: 0;
        }
    }

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 48px;
    width: 100%;
    border: 1px solid #f4c500;
    background: #f4c500;
    border-radius: 30px;
    overflow: hidden;

    p {
        display: inline;
        position: relative;
        color: #000;
        font-weight: 700;
        font-size: 16px;
        line-height: 18px;
        margin: 0;

        .dots-container {
            display: none;
            position: absolute;
            right: -14px;
            bottom: 0;
        }
    }

    &.anim {
        background: transparent;

        p {
            color: #f4c500;
        }

        .dots-container {
            display: flex;

            span {
                &:nth-child(1) {
                    animation: dotsAnim 1.5s ease infinite;
                }

                &:nth-child(2) {
                    animation: dotsAnim 1.5s ease 0.5s infinite;
                }

                &:nth-child(3) {
                    animation: dotsAnim 1.5s ease 1s infinite;
                }
            }
        }

    }

    svg {
        width: 26px;
        fill: #000;
        animation: shake2 800ms infinite ease-out;
        margin-left: 10px;

        @keyframes shake2 {
            0% {
                transform: translateX(-5px);
            }
            50% {
                transform: translateX(5px);
            }

            100% {
                transform: translateX(-5px);
            }
        }
    }

    object {
        display: ${props => props.ready ? "none" : "flex"};
    }
`;

export const ProcessingButtonAnimationTextStyled = styled.object`
    border-radius: 30px;
    position: absolute;
    align-items: center;
    justify-content: center;
    top: -1px;
    left: -1px;
    overflow: hidden;
    margin: 0 !important;
    width: calc(100% + 2px);
    height: 48px;
    background: #f4c500;

    p {
        color: #000 !important;
        line-height: 18px;
    }
`;